import axiosInstance from '../axiosInstance';
import { IResponse } from '../types';
import { requestResources } from '../requestResources';
import { ITicketTemplate } from './types';
import { IdName, LabelValue } from '../../types/common';

const {
  clientPortalTickets,
  clientPortalConfigurations,
  clientPortalCompanies,
  clientPortalTicketTemplates,
} = requestResources;

export const getTicketTemplate = (id: number): IResponse<ITicketTemplate> =>
  axiosInstance.get(`${clientPortalTicketTemplates}/${id}`);

export const getTicketTemplates = (): IResponse<ITicketTemplate[]> =>
  axiosInstance.get(`${clientPortalTicketTemplates}`);

export const getClientPortalConfigurations = (): IResponse<IdName[]> =>
  axiosInstance.get(`${clientPortalConfigurations}`);

export const createTicketFromTemplate = (payload: any): IResponse<{ data: string }> =>
  axiosInstance.post(`${clientPortalTickets}/ticketTemplate`, payload);

export const getClientPortalCompanies = (): IResponse<LabelValue[]> =>
  axiosInstance.get(`${clientPortalCompanies}`);
